import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

export default function AdminLogin() {
  const { login, admin } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  // If already authenticated, bounce straight to the admin panel.
  if (admin && typeof admin === "object") {
    navigate("/admin", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      const next = location.state?.from || "/admin";
      navigate(next, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="relative min-h-screen" data-testid="admin-login-page">
      <div className="rm-cm-bg" aria-hidden="true" />
      <header className="relative z-10 px-6 sm:px-12 py-10">
        <Link
          to="/"
          className="font-cinzel text-xs sm:text-sm tracking-[0.28em] uppercase text-[#FFE7A0]/85 hover:text-[#FFE7A0]"
          data-testid="admin-login-home-link"
        >
          ← The Restoration Matrix
        </Link>
      </header>
      <section className="relative z-10 max-w-md mx-auto px-6 pb-24">
        <div
          className="font-cinzel text-[10px] sm:text-xs tracking-[0.32em] uppercase text-[#FFE7A0]/80 mb-6 text-center"
          data-testid="admin-login-overline"
        >
          Restoration Matrix · Admin
        </div>
        <h1
          className="font-serif-display italic text-3xl sm:text-4xl text-[#FFE7A0] tracking-tight text-center"
          data-testid="admin-login-title"
        >
          Sign in to moderate.
        </h1>
        <form
          onSubmit={submit}
          className="rm-cm-composer mt-10"
          data-testid="admin-login-form"
        >
          <label className="rm-cm-label">
            Email
            <input
              type="email"
              required
              autoComplete="email"
              className="rm-cm-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
            />
          </label>
          <label className="rm-cm-label">
            Password
            <input
              type="password"
              required
              autoComplete="current-password"
              className="rm-cm-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
            />
          </label>
          {error && (
            <div className="rm-cm-alert rm-cm-alert-error" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <div className="rm-cm-composer-foot">
            <span />
            <button
              type="submit"
              className="rm-btn-solid"
              disabled={busy || !email || !password}
              data-testid="admin-login-submit"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
}
